import { path } from 'ramda';

export const selectConfig = path(['config', 'config']);
